// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1d8wV","right":"Navbar_right__2OSAL"};